import script from "./RoleRequiredCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredCalendar.vue?vue&type=style&index=0&id=0fc65966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc65966"]])

export default __exports__